var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add flex-a-c icon",on:{"click":function($event){return _vm.$emit('add')}}},[_vm._v(" "+_vm._s(_vm.$t('acit1'))+" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }